import { render } from "./ClassroomLayout.vue?vue&type=template&id=1e691e9e&bindings={}"
import script from "./ClassroomLayout.vue?vue&type=script&lang=js"
export * from "./ClassroomLayout.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1e691e9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e691e9e')) {
    api.reload('1e691e9e', script)
  }
  
  module.hot.accept("./ClassroomLayout.vue?vue&type=template&id=1e691e9e&bindings={}", () => {
    api.rerender('1e691e9e', render)
  })

}

script.__file = "resources/js/Pages/Layouts/ClassroomLayout.vue"

export default script